import { useCallback } from 'react';

import { useSetupIntent } from '../useSetupIntent';
import { useCustomerSessionQuery } from './graphql/CustomerSession.generated';

export const useCustomerSession = () => {
  const { setupIntentSecret, isFetchingSetupIntent, refetchSetupIntent } =
    useSetupIntent();

  const [response, refetchCustomerSession] = useCustomerSessionQuery({
    requestPolicy: 'network-only',
  });

  const refetch = useCallback(() => {
    refetchCustomerSession({ requestPolicy: 'network-only' });
    void refetchSetupIntent({});
  }, [refetchCustomerSession, refetchSetupIntent]);

  const customerId = response.data?.customerPaymentInfo?.id;
  const customerSessionClientSecret =
    response.data?.customerPaymentInfo?.paymentSessionId;
  const isFetchingCustomerSession = response.fetching || isFetchingSetupIntent;
  const isMissingCustomerSession =
    !customerSessionClientSecret || !setupIntentSecret;

  return {
    customerId,
    setupIntentSecret,
    customerSessionClientSecret,
    isFetchingCustomerSession,
    isMissingCustomerSession,
    refetch,
  };
};
